import React, { useState } from 'react';
import CardActualizacionMasiva from "../../../../General/Excel/CardActualizacionMasiva";
import { putExcelLiquidacionesFeeLogisticoApi } from "../../../../../api/axios";
import { formatFile } from '../../../../../utilities/formatFile';
import { toast } from "react-toastify";

export default function ActualizacionMasivaFeeLogistico() {
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const isValidUpdateExcel = () => {
    if (!file) {
      toast.warn('No se ha seleccionado ningún archivo excel');
      return false;
    }
    return true;
  }

  const exportExcel = async () => {
    setIsLoading(true);

    let excelBase64 = await formatFile(file, "xlsx");
    let response = putExcelLiquidacionesFeeLogisticoApi({ file: excelBase64 });

    response.then(res => {
      toast.success("Los fee logísticos se actualizaron correctamente.")
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.warn(error))
        : toast.error("Los fee logísticos no pudieron ser actualizados");
    }).finally(() => {
      setIsLoading(false);
    });
  }

  const excelTemplate = {
    fileResultName: "Modelo Actualización FeeLogístico",
    sheetName: "Fee Logístico",
    columns: [{ 
      IdFee: 0,
      Escala: 0,
      Amba: 0,
      Interior: 0,
      Patagonia: 0
    }]
  };

  return (
    <div className="card p-4">
      <CardActualizacionMasiva 
        title="Fee Logístico"
        btnText="Actualizar Fee Logístico"
        dataSet={excelTemplate}
        isLoading={isLoading}
        updateFile={setFile}
        exportExcel={exportExcel}
        isValidUpdateExcel={isValidUpdateExcel}
      />
    </div>
  )
}